import React, { useState, useEffect } from 'react';
import { Menu, X } from 'lucide-react';

const Header = () => {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const scrollToSection = (id) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
      setIsMobileMenuOpen(false);
    }
  };

  return (
    <header className={`header ${isScrolled ? 'scrolled' : ''}`}>
      <div className="header-container">
        <div className="logo-section">
          <div className="logo-icon">
            <img 
              src="https://customer-assets.emergentagent.com/job_authentic-meals/artifacts/vut25uz5_CSS%20LOGO%20PNG.png" 
              alt="CSS Caribbean Meal Logo" 
              className="company-logo"
            />
          </div>
          <div className="logo-text">
            <span className="logo-main">CSS Caribbean Meal</span>
            <span className="logo-tagline">Great Tasting Food Every Time!</span>
          </div>
        </div>
        
        <nav className="desktop-nav">
          <button onClick={() => scrollToSection('hero')} className="nav-link">Home</button>
          <button onClick={() => scrollToSection('products')} className="nav-link">Products</button>
          <button onClick={() => scrollToSection('catering')} className="nav-link">Catering</button>
          <button onClick={() => scrollToSection('retailers')} className="nav-link">Where to Buy</button>
          <button onClick={() => scrollToSection('story')} className="nav-link">Our Story</button>
          <button onClick={() => scrollToSection('footer')} className="nav-link">Contact</button>
        </nav>

        <button 
          className="mobile-menu-btn"
          onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
        >
          {isMobileMenuOpen ? <X size={24} /> : <Menu size={24} />}
        </button>
      </div>

      {isMobileMenuOpen && (
        <div className="mobile-menu">
          <button onClick={() => scrollToSection('hero')} className="mobile-nav-link">Home</button>
          <button onClick={() => scrollToSection('products')} className="mobile-nav-link">Products</button>
          <button onClick={() => scrollToSection('catering')} className="mobile-nav-link">Catering</button>
          <button onClick={() => scrollToSection('retailers')} className="mobile-nav-link">Where to Buy</button>
          <button onClick={() => scrollToSection('story')} className="mobile-nav-link">Our Story</button>
          <button onClick={() => scrollToSection('footer')} className="mobile-nav-link">Contact</button>
        </div>
      )}
    </header>
  );
};

export default Header;
